import { atom } from 'jotai';

export const modalAtom = atom({
  isOpen: false,
  title: null,
  content: null,
  action: null,
  fullScreen: false,
});
